module.exports = __webpack_public_path__ + "img/horizontal_4_2_7016.b9cc0a7e.png";